<template>
  <div class="container-xl h-75 templateCase">
    <div class="templateCase-content">
      <div
        v-if="screenWidth >= 992"
        class="templateCase-content-title d-flex align-items-end"
        :class="tilteAnimate"
      >
        <div class="d-flex">
          <div class="colon"></div>
          <div class="templateCase-content-title-icon page-title">模版案例</div>
        </div>
        <span class="words opacity-1 mb-1">高端客制版型选择众多</span>
      </div>
    </div>
    <div class="templateCase-toggle d-flex">
      <button
        class="btn templateCase-toggle-btn"
        :class="{ 'active': currentSwiper === 'swiper1' }"
        @click="switchSwiper('swiper1')"
      >
        手機版
      </button>
      <button
        class="btn templateCase-toggle-btn"
        :class="{ 'active': currentSwiper === 'swiper2' }"
        @click="switchSwiper('swiper2')"
      >
        電腦版
      </button>
      <button
        class="btn templateCase-toggle-btn"
        :class="{ 'active': currentSwiper === 'credit' }"
        @click="switchSwiper('credit')"
      >
        信用版
      </button>
    </div>

    <!-- 手機版 Swiper -->
    <swiper
      v-show="currentSwiper === 'swiper1'"
      class="templateCase-swiper swiper1"
      ref="mySwiper1"
      :options="swiperOption1"
    >
      <swiper-slide v-for="(group, index) in mobileGroups" :key="'mobile-' + index">
        <div class="form-row">
          <div v-for="item in group" :key="item.id" class="col-md-4 templateCase-col">
            <div class="templateCase-card">
              <div class="templateCase-card-imagebox" :style="{ backgroundImage: `url(${item.image})` }">
                <a data-toggle="modal" data-target="#myModal" @click="openModal(item.id)">Details</a>
              </div>
              <div class="templateCase-card-info">
                <span>{{ item.label }}</span>
                <a v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer" class="templateCase-card-link" @click.stop>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                  預覽
                </a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper1-pagination swiper-mt" slot="pagination"></div>
      <div class="swiper1-button-prev" slot="button-prev"></div>
      <div class="swiper1-button-next" slot="button-next"></div>
    </swiper>

    <!-- 電腦版 Swiper -->
    <swiper
      v-show="currentSwiper === 'swiper2'"
      class="templateCase-swiper swiper2"
      ref="mySwiper2"
      :options="swiperOption2"
    >
      <template v-if="screenWidth >= 768">
        <swiper-slide v-for="(group, gIndex) in desktopGroups" :key="'dg-' + gIndex">
          <div v-for="(row, rIndex) in group" :key="'dr-' + rIndex" class="form-row">
            <div
              v-for="item in row"
              :key="item.id"
              class="col-md-4 templateCase-col"
            >
              <div class="templateCase-card">
                <div class="templateCase-card-imagebox" :class="'templateCase-card-imagebox-web' + item.num">
                  <a data-toggle="modal" data-target="#myModal" @click="openModal(item.id)">Details</a>
                </div>
                <div class="templateCase-card-info">
                  <span>{{ item.label }}</span>
                  <a :href="item.url" target="_blank" class="templateCase-card-link" @click.stop>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    預覽
                  </a>
                </div>
              </div>
            </div>
            <div v-for="n in (3 - row.length)" :key="'empty-' + n" class="col-md-4 templateCase-col"></div>
          </div>
        </swiper-slide>
      </template>
      <template v-else>
        <swiper-slide v-for="item in desktopTemplates" :key="'ds-' + item.id">
          <div class="row">
            <div class="col-12 templateCase-col">
              <div class="templateCase-card">
                <div class="templateCase-card-imagebox" :class="'templateCase-card-imagebox-web' + item.num">
                  <a data-toggle="modal" data-target="#myModal" @click="openModal(item.id)">Details</a>
                </div>
                <div class="templateCase-card-info">
                  <span>{{ item.label }}</span>
                  <a :href="item.url" target="_blank" class="templateCase-card-link" @click.stop>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    預覽
                  </a>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </template>
      <div class="swiper2-pagination swiper-mt" slot="pagination"></div>
      <div class="swiper2-button-prev" slot="button-prev"></div>
      <div class="swiper2-button-next" slot="button-next"></div>
    </swiper>
    <swiper
      v-show="currentSwiper === 'credit'"
      class="templateCase-swiper credit-swiper"
      :options="creditSwiperOption"
    >
      <swiper-slide v-for="(group, index) in creditGroups" :key="'credit-' + index">
        <div class="form-row">
          <div v-for="item in group" :key="item.id" class="col-md-4 templateCase-col">
            <div class="templateCase-card">
              <div class="templateCase-card-imagebox" :style="{ backgroundImage: `url(${item.image})` }">
                <a data-toggle="modal" data-target="#myModal" @click="openModal(item.id)">Details</a>
              </div>
              <div class="templateCase-card-info">
                <span>{{ item.label }}</span>
                <a v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer" class="templateCase-card-link" @click.stop>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                  預覽
                </a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="credit-pagination swiper1-pagination swiper-mt" slot="pagination"></div>
      <div class="credit-button-prev swiper1-button-prev" slot="button-prev"></div>
      <div class="credit-button-next swiper1-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { mobileTemplates, creditTemplates, getDemoUrl } from './templates';

const desktopTemplates = [
  { num: 1,  id: 'V588-01', label: 'DOING-01', url: getDemoUrl(1) },
  { num: 2,  id: 'V588-02', label: 'DOING-02', url: getDemoUrl(2) },
  { num: 3,  id: 'V588-03', label: 'DOING-03', url: getDemoUrl(3) },
  { num: 4,  id: 'V588-04', label: 'DOING-04', url: getDemoUrl(4) },
  { num: 5,  id: 'V588-05', label: 'DOING-05', url: getDemoUrl(5) },
  { num: 6,  id: 'V588-06', label: 'DOING-06', url: getDemoUrl(6) },
  { num: 7,  id: 'V588-07', label: 'DOING-07', url: getDemoUrl(7) },
  { num: 8,  id: 'V588-08', label: 'DOING-08', url: getDemoUrl(8) },
  { num: 9,  id: 'V588-09', label: 'DOING-09', url: getDemoUrl(9) },
  { num: 10, id: 'V588-10', label: 'DOING-10', url: getDemoUrl(10) },
  { num: 11, id: 'V588-11', label: 'DOING-11', url: getDemoUrl(11) },
  { num: 12, id: 'V588-12', label: 'DOING-12', url: getDemoUrl(12) },
  { num: 13, id: 'V588-13', label: 'DOING-13', url: getDemoUrl(13) },
  { num: 14, id: 'V588-14', label: 'DOING-14', url: getDemoUrl(14) },
  { num: 15, id: 'V588-15', label: 'DOING-15', url: getDemoUrl(15) },
  { num: 16, id: 'V588-16', label: 'DOING-16', url: getDemoUrl(16) },
  { num: 17, id: 'V588-17', label: 'DOING-17', url: getDemoUrl(17) },
  { num: 18, id: 'V588-18', label: 'DOING-18', url: getDemoUrl(18) },
  { num: 19, id: 'V588-19', label: 'DOING-19', url: getDemoUrl(19) },
  { num: 20, id: 'V588-20', label: 'DOING-20', url: getDemoUrl(20) },
];

function chunkArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

export default {
  name: 'Index',
  props: {
    slideData: {
      type: String,
      required: true
    },
    screenWidth: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentSwiper: 'swiper1',
      creditTemplates,
      creditSwiperOption: {
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.credit-button-next',
          prevEl: '.credit-button-prev',
        },
        pagination: { el: '.credit-pagination', clickable: true },
        loop: false,
      },
      mobileTemplates,
      desktopTemplates,
      swiperOption1: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
          waitForTransition: true
        },
        navigation: {
          nextEl: ".swiper1-button-next",
          prevEl: ".swiper1-button-prev",
          hideOnClick: true
        },
        pagination: {
          el: '.swiper1-pagination',
          clickable: true,
        },
        loop: false
      },
      swiperOption2: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
          waitForTransition: true
        },
        navigation: {
          nextEl: ".swiper2-button-next",
          prevEl: ".swiper2-button-prev",
          hideOnClick: true
        },
        pagination: {
          el: '.swiper2-pagination',
          clickable: true,
        },
        loop: false
      },
    }
  },
  computed: {
    creditGroups() {
      return chunkArray(this.creditTemplates, this.screenWidth >= 768 ? 3 : 1);
    },
    tilteAnimate() {
      return {
        'animate__animated': this.slideData === 'templateCase',
        'animate__lightSpeedInLeft': this.slideData === 'templateCase',
        'opacity-0': this.slideData !== 'templateCase',
        'opacity-1': this.slideData === 'templateCase'
      }
    },
    mobileGroups() {
      return chunkArray(this.mobileTemplates, this.screenWidth >= 768 ? 3 : 1);
    },
    desktopGroups() {
      // 每個 slide 顯示 6 個（2 行 x 3 列）
      const groups = chunkArray(desktopTemplates, 6);
      return groups.map(group => chunkArray(group, 3));
    }
  },
  methods: {
    openModal(num) {
      this.$emit('openModal', num)
    },
    switchSwiper(swiperName) {
      this.currentSwiper = swiperName;
    }
  },
}
</script>
